import { z } from "zod";
import { CycleQuestionKinds } from "./cycleQuestionSchemas.ts";
import { GetCycleQuestionResultsInputSchema, GetCycleReviewThemesInputSchema, ListCycleCalibrationRevieweesInputSchema, ListCycleRevieweesInputSchema, ListCycleRevieweeScoresInputSchema } from "./reviewCyclesContract.ts";

const EXPORTS_PREFIX = "/api/review-cycles/exports";

export const CYCLE_ALL_REVIEWS_PDF_EXPORT_PATH = `${EXPORTS_PREFIX}/all-reviews-zip`;
export const CYCLE_ALL_REVIEWS_CSV_EXPORT_PATH = `${EXPORTS_PREFIX}/all-reviews-csv`;

export const CYCLE_REPORT_CSV_EXPORT_PATHS = {
    progression: `${EXPORTS_PREFIX}/progression-csv`,
    scores: `${EXPORTS_PREFIX}/scores-csv`,
    questions: `${EXPORTS_PREFIX}/questions-csv`,
    calibration: `${EXPORTS_PREFIX}/calibration-csv`,
    themes: `${EXPORTS_PREFIX}/themes-csv`
} as const;

export const ExportCycleProgressionInputSchema = ListCycleRevieweesInputSchema.omit({ pageSize: true, continuationToken: true });
export type ExportCycleProgressionInput = z.infer<typeof ExportCycleProgressionInputSchema>;

export const ExportCycleScoresInputSchema = ListCycleRevieweeScoresInputSchema.omit({ pageSize: true, continuationToken: true });
export type ExportCycleScoresInput = z.infer<typeof ExportCycleScoresInputSchema>;

export const ExportCycleQuestionsInputSchema = GetCycleQuestionResultsInputSchema.extend({ questionType: z.enum(CycleQuestionKinds).optional() });
export type ExportCycleQuestionsInput = z.infer<typeof ExportCycleQuestionsInputSchema>;

export const ExportCycleCalibrationInputSchema = ListCycleCalibrationRevieweesInputSchema.omit({ pageSize: true, continuationToken: true });
export type ExportCycleCalibrationInput = z.infer<typeof ExportCycleCalibrationInputSchema>;

export const ExportCycleThemesInputSchema = GetCycleReviewThemesInputSchema;
export type ExportCycleThemesInput = z.infer<typeof ExportCycleThemesInputSchema>;

export type ExportCycleAllReviewsInput = ExportCycleProgressionInput;
